export default __webpack_public_path__ + "static/media/63.7c95a7ef.jpg";